import { StatementTemplate } from 'store/products/types'
import { Template } from 'store/statement/types'

export default (template: Template): StatementTemplate => ({
  name: template.templateName,
  id: template.templateGroupId,
})
